module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "1em"
    }
  }, [_c('b', [_vm._v("Praise for "), _c('i', [_vm._v("The Glory")]), _vm._v(" and "), _c('i', [_vm._v("The Hope")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b', [_c('i', [_vm._v("The Hope")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "1em"
    }
  }, [_vm._v("A "), _c('i', [_vm._v("New York Times")]), _vm._v(" Bestseller")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "margin-top": "0.5em"
    }
  }, [_vm._v("“One of our best writers today—a modern Charles Dickens—is Herman Wouk.… "), _c('i', [_vm._v("The Hope")]), _vm._v(" is not only a good read, but it also causes a good think.”")]), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("—"), _c('i', [_vm._v("The New York Times Magazine")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "margin-top": "0.5em"
    }
  }, [_vm._v("“Rich and satisfying … deftly portrays the human face of inhuman conflict.”")]), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("—"), _c('i', [_vm._v("The Plain Dealer")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "margin-top": "0.5em"
    }
  }, [_vm._v("“Seamlessly weaves epic events into everyday life.… Inspiring and full of excitement.”")]), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("—"), _c('i', [_vm._v("Entertainment Weekly")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "margin-top": "0.5em"
    }
  }, [_vm._v("“Heroic storytelling.… Wouk’s fictional characters humanize history.”")]), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("—"), _c('i', [_vm._v("The Washington Post Book World")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "margin-top": "0.5em"
    }
  }, [_vm._v("“Herman Wouk is a master of the historical novel.”")]), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("—"), _c('i', [_vm._v("Los Angeles Times")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('b', [_c('i', [_vm._v("The Glory")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "margin-top": "0.5em"
    }
  }, [_vm._v("“Superb.… A stirring novel of a brave period and place.… There is historical scope in "), _c('i', [_vm._v("The Glory")]), _vm._v(" that conveys indelibly the sense of history that dignifies the past and sustains the present.”")]), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("—"), _c('i', [_vm._v("The Washington Times")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "margin-top": "0.5em"
    }
  }, [_vm._v("“Wouk long ago proved his skill at the delicate balancing act which is the historical novel.… He has said that his mission in writing "), _c('i', [_vm._v("The Hope")]), _vm._v(" and "), _c('i', [_vm._v("The Glory")]), _vm._v(" is to give ‘a vivid sense of what it was like to live in that embattled little land’ when these historical events were taking place: he accomplishes what he set out to do, and earns the fireworks that grace his final pages.”")]), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("—"), _c('i', [_vm._v("The Times")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-585bdbf7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/praise.vue
// module id = 57
// module chunks = 0